import { CART_MODULE } from "@/api_framework/api_config";
import { INewCartResponse } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useNewCartAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (
      customerId: string,
      clinicId: string,
      clinicName: string,
      pet_id?: string,
      service_id?: string,
      sub_service_id?: string,
    ) => {
      dispatch(
        setLoading({
          key: "isNewCartInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: any | null = await axios
          .get(`${CART_MODULE?.NEW_CART?.baseURL}`, {
            params: {
              clinic_id: clinicId,
              clinic_name: clinicName,
              customer_id: customerId,
              service_id: service_id,
              pet_id: pet_id,
              sub_service_id: sub_service_id,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<INewCartResponse>) => {
            dispatch(
              setLoading({
                key: "isNewCartInProgress",
                status: false,
              }),
            );
            if (res.data.status === true) {
              return { cart_id: res.data.data.cart_id };
            } else {
              return { cart_id: null };
            }
          })
          .catch((e: AxiosError) => {
            dispatch(
              setLoading({
                key: "isNewCartInProgress",
                status: false,
              }),
            );
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { cart_id: null };
          });
        return response;
      } catch (e) {
        captureError(e);
      }
    },
    [dispatch],
  );
  return { execute };
};
